import React from 'react'

import { Tab } from 'components'
import { useTabs } from 'hooks'
import { TabsProvider } from 'hooks/useTabs/provider'

import AddNew from './components/AddNew'
import Search from './components/Search'
import { WorkAccidentOccurrenceProvider } from './context'


const WorkAccidentOccurrenceComponent: React.FC = () => {
  const {
    tabs,
    handleChangeTab,
    selectedTab
  } = useTabs(['Pesquisar', 'Adicionar Novo'])

  return (
    <>
      <Tab tabs={tabs} value={selectedTab.position} handleChange={handleChangeTab} />
      {selectedTab.position === 0 && <Search />}
      {selectedTab.position === 1 && <AddNew />}
      {selectedTab.position === 2 && <AddNew justRead />}
    </>
  )
}

const WorkAccidentOccurrence: React.FC = () => {
  return (
    <TabsProvider>
      <WorkAccidentOccurrenceProvider>
        <WorkAccidentOccurrenceComponent />
      </WorkAccidentOccurrenceProvider>
    </TabsProvider>
  )
}

export default WorkAccidentOccurrence
